import { Image } from '@chakra-ui/image';
import { Heading } from '@chakra-ui/layout';

import { images } from '@/shared/assets';

export const HeadLogo: React.FC = () => (
  <Image
    htmlWidth="55"
    htmlHeight="40"
    fit="contain"
    // src={images('logo', { convert: 'webp' })}
    src={images('logo')}
    alt="File Uploader"
    title="File Uploader"
    loading="eager"
    fallback={
      <Heading h="full" textStyle="h4">
        File Uploader
      </Heading>
    }
  />
);
